import { combineEpics } from 'redux-observable';
import { of, empty } from '../common/rxjs/observable';
import { map, catchError } from '../common/rxjs/operators';
import { createAction } from '../common/actions';
import { actionMergeMap } from '../common/epics';
import Actions from './actions';
import API from './api';
import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { tracker } from '..//lib/tracker';
import { captureMessage } from '../common/sentry';
const catchErrorToFailAction = (action, key) => {
  return catchError(error =>
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'FAIL' does not exist on type '{}'.
  of(createAction(Actions.FAIL, {
    key,
    error,
    action
  })));
};
export default combineEpics(actionMergeMap(Actions.ADD_SUBMIT, action => API.add(action.payload).pipe(map(response =>
// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
createAction(Actions.ADD_SUCCESS, response)), catchErrorToFailAction(action, 'emails.failures.titles.addFail'))), actionMergeMap(Actions.DELETE_SUBMIT, action => API.delete(action.payload).pipe(map(() => createAction(Actions.DELETE_SUCCESS, action.payload)), catchErrorToFailAction(action, 'emails.failures.titles.deleteFail'))), actionMergeMap(Actions.RESEND_VERIFY_SUBMIT, action => API.resendVerification(action.payload).pipe(map(() => createAction(Actions.RESEND_VERIFY_SUCCESS, action.payload)), catchErrorToFailAction(action, 'emails.failures.titles.resendVerifyFail'))), actionMergeMap(Actions.SET_PRIMARY_SUBMIT, action => API.setPrimary(action.payload).pipe(map(() => createAction(Actions.SET_PRIMARY_SUCCESS, action.payload)), catchErrorToFailAction(action, 'emails.failures.titles.setPrimaryFail'))), actionMergeMap(Actions.SET_PRIMARY_SUCCESS, () => {
  tracker.track('usage', {
    action: 'setPrimaryLoginEmail'
  });
  return empty();
}), actionMergeMap(Actions.ADD_SUCCESS, action => {
  FloatingAlertStore.addAlert({
    titleText: I18n.text('emails.added.title', action.payload),
    message: I18n.text('emails.resentVerify.message'),
    timeout: 5000,
    type: 'success'
  });
  tracker.track('usage', {
    action: 'addLoginEmail'
  });
  return empty();
}), actionMergeMap(Actions.DELETE_SUCCESS, action => {
  FloatingAlertStore.addAlert({
    titleText: I18n.text('emails.deleted.title', action.payload),
    timeout: 5000,
    type: 'success'
  });
  tracker.track('usage', {
    action: 'deleteLoginEmail'
  });
  return empty();
}), actionMergeMap(Actions.RESEND_VERIFY_SUCCESS, action => {
  FloatingAlertStore.addAlert({
    titleText: I18n.text('emails.resentVerify.title', action.payload),
    message: I18n.text('emails.resentVerify.message'),
    timeout: 5000,
    type: 'success'
  });
  tracker.track('usage', {
    action: 'resendVerifyLoginEmail'
  });
  return empty();
}), actionMergeMap(Actions.FAIL, action => {
  FloatingAlertStore.addAlert({
    titleText: I18n.text(action.payload.key, action.payload),
    message: I18n.text('emails.failures.message'),
    type: 'danger'
  });
  captureMessage('login email failure', {
    extra: action.payload
  });
  return empty();
}));